import { ReactNode } from 'react';
import { SvgContainer, renderSVG } from './';
import { Facebook, LinkedIn, Twitter } from 'icons/index';

export interface SocialSharingProps {
  url: string;
  title: string;
}

//
// Component for Sharing on Social Media
const SocialSharing = ({ url, title }: SocialSharingProps): ReactNode => {
  return (
    <SvgContainer>
      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
        target="_blank"
        rel="nofollow noopener"
      >
        <span className="visually-hidden">Share on Facebook</span>
        {renderSVG(Facebook, '20px')}
      </a>

      <a
        href={`https://twitter.com/intent/tweet?url=${url}&text=${title}`}
        target="_blank"
        rel="nofollow noopener"
      >
        <span className="visually-hidden">Share on Twitter</span>
        {renderSVG(Twitter, '20px')}
      </a>

      <a
        href={`https://www.linkedin.com/shareArticle?url=${url}&title=${title}`}
        target="_blank"
        rel="nofollow noopener"
      >
        <span className="visually-hidden">Share on LinkedIn</span>
        {renderSVG(LinkedIn, '20px')}
      </a>
    </SvgContainer>
  );
};

export default SocialSharing;
